module.exports = __webpack_public_path__ + "img/tu.32a812bd.jpg";